import React, { FC } from 'react';
import { Col as BaseCol, ColProps } from 'antd';

const Col: FC<ColProps> = ({
  span = 24,
  ...props
}) => (
  <BaseCol
    span={span}
    {...props}
  />
);

export default Col;
